<template>
  <div class="">
    <!--    <AllRouter></AllRouter>-->
    <p style="margin-left: 20px;font-weight: bold">您没有该操作权限!</p>
  </div>
</template>
<script>
// import AllRouter from '../../components/all-router'

export default {
  name: 'p404',
  // components: { AllRouter },
  props: [],
  data () {
    return {}
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>
